/**
 * Хелпер для рендеринга ошибки валидации
 *
 * @param field
 * @return {string[]}
 */
export const messageHelper = field => {
  const errors = [];
  if (!field.$dirty) return errors;
  if ("minLength" in field && !field.minLength) errors.push("Формат неверный");
  if ("maxLength" in field && !field.maxLength) errors.push("Формат неверный");
  if ("email" in field && !field.email) errors.push("Формат email неверный");
  if ("required" in field && !field.required) errors.push("Поле обязательно для заполнения");
  if ("numeric" in field && !field.numeric) errors.push("Поле может содержать только числа");
  if ("minLength" in field && !field.minLength) errors.push("Ошибка, минимальная длина");
  return errors;
};
